import React, { useState, useEffect } from "react";
import axios from "axios";
import SideBar from "../SideBar/sideBar";
import { disputeRes } from "../api/Service";
import { DisputeLetter, Sendmail } from "../api/Service";
import '../../index.css';
import LockIcon from '@mui/icons-material/Lock';
import { useNavigate } from "react-router-dom";
import ReactQuill from 'react-quill';
import Modal from 'react-modal';

const RemoveCollections = () => {
    const [step, setStep] = useState('select')
    const [disputeType, setDisputeType] = useState([])
    const [disputeType1, setDisputeType1] = useState('')
    const [loading, setLoading] = useState(false);
    const [generatedLetter, setGeneratedLetter] = useState('')
    const [generatedLetter1, setGeneratedLetter1] = useState('')
    const [showMail, setShowMail] = useState(1)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [state, setState] = useState('')
    const navigate = useNavigate()
    const [Disputeletter, setDisputeLetter] = useState('')
    const [userInfo, setUserInfo] = useState({
        name: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        email: '',
        phone: '',
        companyName: '',
        companyAddress: '',
        companyCity: '',
        companyState: '',
        companyZipCode: '',
    })
    const FirstName = localStorage.getItem('firstName') || '';
    const LastName = localStorage.getItem('lastName') || '';
    const initials = `${FirstName.charAt(0)}${LastName.charAt(0)}`

    const fetchDisputeTypes = async () => {
        try {
            const response = await disputeRes();
            if (Array.isArray(response.data)) {
                setDisputeType(response.data);
                console.log("hiii", response.data);
            } else {
                setDisputeType([])
                console.error("Error: Data received is not an array");
            }
        } catch (error) {
            //setDisputeType([])
            console.error("Error fetching dispute types:", error);
        }
    };

    useEffect(() => {
        fetchDisputeTypes();
    }, []);
    const handleMail = () => {
        setShowMail(2)
        //setGeneratedLetter()
    }
    const handleDisputeTypeSelect = (type) => {
        setDisputeType1(type);
        setStep('userInfo');
    }
    const handleUserInfoChange = (e) => {
        setUserInfo({ ...userInfo, [e.target.name]: e.target.value });
    };
    const handleUserInfoSubmit = (e) => {
        e.preventDefault();
        setStep('generate');
    };
    const goBack = () => {
        if (step === 'userInfo') {
            setStep('select');
        } else if (step === 'generate') {
            setStep('userInfo');
        }
    };
    const PlanTypeName = localStorage.getItem('PlanTypeName')
    const stripHTML = (html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html,'text/html');
        return doc.body.textContent || "";
    };

    const generateDisputeLetter = async () => {
        setLoading(true);
        try {
            console.log("hiiiii")
            const data = {
                role: 'user',
                disputeTopic: `Generate a dispute letter for a ${disputeType1} credit dispute. Ensure it's tailored to the specific legal context and incorporates the best applicable laws. Use the following information:
                fullName: ${userInfo.name}
                city:${userInfo.city}
                address: ${userInfo.address} 
                email: ${userInfo.email}
                state:${userInfo.state}
                zipCode:${userInfo.zipCode}  
                phone: ${userInfo.phone}
                companyName: ${userInfo.companyName}
                companyAddress: ${userInfo.companyAddress}  
                companyCity: ${userInfo.companyCity}
                companyState: ${userInfo.companyState}
                companyZipCode:${userInfo.companyZipCode}`
            }
            const gptResponse = await DisputeLetter(data)

            const gptData = gptResponse.data;
            const readableData = stripHTML(gptData);

            //   const claudeResponse = await fetch('', {
            //     method: 'POST',
            //     body: JSON.stringify({
            //       messages: [
            //         {
            //           role: 'system',
            //           content: 'You are a legal expert specializing in credit disputes. Review and improve the following dispute letter, ensuring it includes all relevant and credible laws that could apply to the dispute.'
            //         },
            //         {
            //           role: 'user',
            //           content: `Review and improve this dispute letter for a ${disputeType} credit dispute: ${gptData.choices[0].message.content}`
            //         }
            //       ]
            //     }),
            //   });
            //   const claudeData = await gptData.json();
            setGeneratedLetter1(gptData)

            setGeneratedLetter(readableData);
        } catch (error) {
            console.error('Error generating dispute letter:', error);
            setGeneratedLetter('An error occurred while generating the dispute letter. Please try again.');
        } finally {
            setLoading(false)
        }

    };
    const handleSubmit = async (e) => {

        setLoading(true);
        e.preventDefault();
        const data = {
            RecevierAddress: {
                firstName: userInfo.companyName,
                lastName: '',
                companyName: userInfo.companyName,
                addressLine1: userInfo.companyAddress,
                addressLine2: '',
                city: userInfo.companyCity,
                provinceOrState: userInfo.companyState,
                email: ''
            },
            SenderAddress: {
                firstName: userInfo.name,
                lastName: '',
                companyName: '',
                addressLine1: userInfo.address,
                addressLine2: '',
                city: userInfo.city,
                provinceOrState: userInfo.state,
                email: userInfo.email,

            },
            Letterdiscription: disputeType1,
            disputeLetter: generatedLetter1

        }

        try {
            const response = await Sendmail(data);
            console.log(response)
            if (response.status === 200) {
                setIsModalOpen(true)
            }
            setLoading(false)
        } catch (error) {
            console.log(error)
        }



    }
    const closeModal = () => {
        setIsModalOpen(false);
        setUserInfo('')
        setGeneratedLetter('')
        setShowMail(1)
        setStep('select')
    };

    return (

        <div className="flex h-100% bg-[#121212]">
            <SideBar />
            <main className="flex-1 overflow-y-auto p-6">

            <div className="flex flex-col md:flex-row justify-between items-center mt-5 mb-4">
                    <h1 className="text-2xl md:text-3xl font-bold text-white">AI Remove Collections</h1>
                    <div className="ml-0 md:ml-[30.75rem] mt-4 md:mt-0">
                        {PlanTypeName?.includes('Lifetime Access') && (
                            <h1 className="text-white font-semibold">You Have Lifetime Access</h1>
                        )}
                    </div>
                    <div className="w-10 h-10 bg-purple-500 rounded-full flex items-center justify-center mt-4 md:mt-0">
                        <span className="text-white font-bold">{initials}</span>
                    </div>
                </div>
                <div className="videoyou bg-[#1E1E1E] sm:p-4 sm:p-6 rounded-lg mx-auto mb-8" style={{ "height": "500px", "maxWidth": "850px" }}>
                    <div className="relative h-full">
                        <iframe
                            width="100%"
                            height="100%"
                            src="https://player.vimeo.com/video/1021518016"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="Video"
                            className="absolute inset-0 rounded-lg"
                        ></iframe>
                    </div>


                </div>
                <div className="bg-[#2d2c2c] shadow-lg rounded-lg p-6 mb-8">

                    <div>
                        {PlanTypeName === 'Free' ? (<h2 className="text-2xl font-semibold mb-4 text-white">
                            Remove Collections With AI <LockIcon className='mr-2' />
                        </h2>) : (<h2 className="text-2xl font-semibold mb-4 text-white">
                            Remove Collections With AI
                        </h2>)}
                        {step === 'select' && (
                            <div>
                                {PlanTypeName === 'Free' ? (<> <p className="text-white font-semibold">
                                    Select the type of credit dispute you're dealing with:
                                </p>
                                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mt-4">
                                        {console.log(disputeType)}
                                        {disputeType ? (
                                            disputeType.map((type, index) => (
                                                <button
                                                    key={index}
                                                    onClick={() => navigate('/app/subscription')}
                                                    className="bg-purple-600 hover:bg-purple-800 text-white font-bold py-2 px-4 rounded cursor-pointer text-sm sm:text-base"
                                                >
                                                    {type.title}
                                                </button>
                                            ))
                                        ) : (
                                            <p className="text-white text-center col-span-full">No dispute types available.</p>
                                        )}
                                    </div></>)
                                    : (<> <p className="text-white font-semibold">
                                        Select the type of credit dispute you're dealing with:
                                    </p>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mt-4">
                                            {console.log(disputeType)}
                                            {disputeType ? (
                                                disputeType.map((type, index) => (
                                                    <button
                                                        key={index}
                                                        onClick={() => handleDisputeTypeSelect(type.title)}
                                                        className="bg-purple-600 hover:bg-purple-800 text-white font-bold py-2 px-4 rounded cursor-pointer text-sm sm:text-base"
                                                    >
                                                        {type.title}
                                                    </button>
                                                ))
                                            ) : (
                                                <p className="text-white text-center col-span-full">No dispute types available.</p>
                                            )}
                                        </div></>)}
                            </div>)}
                        {step === 'userInfo' && (
                            <div>
                                <form onSubmit={handleUserInfoSubmit} className="space-y-4 bg-[#2d2c2c]">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <input type="text" name="name" placeholder="Full Name" value={userInfo.name} onChange={handleUserInfoChange} className="bg-[#2A2A2A] rounded p-2 text-white" required />
                                        <input type="text" name="address" placeholder="Address" value={userInfo.address} onChange={handleUserInfoChange} className="bg-[#2A2A2A] rounded p-2 text-white" required />
                                        <input type="text" name="city" placeholder="City" value={userInfo.city} onChange={handleUserInfoChange} className="bg-[#2A2A2A] rounded p-2 text-white" required />
                                        <input type="text" name="state" placeholder="State" value={userInfo.state} onChange={handleUserInfoChange} className="bg-[#2A2A2A] rounded p-2 text-white" required />
                                        <input type="text" name="zipCode" placeholder="Zip Code" value={userInfo.zipCode} onChange={handleUserInfoChange} className="bg-[#2A2A2A] rounded p-2 text-white" required />
                                        <input type="email" name="email" placeholder="Email" value={userInfo.email} onChange={handleUserInfoChange} className="bg-[#2A2A2A] rounded p-2 text-white" required />
                                        <input type="tel" name="phone" placeholder="Phone" value={userInfo.phone} onChange={handleUserInfoChange} className="bg-[#2A2A2A] rounded p-2 text-white" required />
                                        <input type="text" name="companyName" placeholder="Company Name" value={userInfo.companyName} onChange={handleUserInfoChange} className="bg-[#2A2A2A] rounded p-2 text-white" required />
                                        <input type="text" name="companyAddress" placeholder="Company Address" value={userInfo.companyAddress} onChange={handleUserInfoChange} className="bg-[#2A2A2A] rounded p-2 text-white" required />
                                        <input type="text" name="companyCity" placeholder="Company City" value={userInfo.companyCity} onChange={handleUserInfoChange} className="bg-[#2A2A2A] rounded p-2 text-white" required />
                                        <input type="text" name="companyState" placeholder="Company State" value={userInfo.companyState} onChange={handleUserInfoChange} className="bg-[#2A2A2A] rounded p-2 text-white" required />
                                        <input type="text" name="companyZipCode" placeholder="Company Zip Code" value={userInfo.companyZipCode} onChange={handleUserInfoChange} className="bg-[#2A2A2A] rounded p-2 text-white" required />
                                    </div>
                                    <div className="flex space-x-4">
                                        <button type="submit" className="bg-green-600 hover:bg-green-500 text-white font-bold py-2 px-4 rounded">
                                            Next
                                        </button>
                                        <button type="button" onClick={goBack} className="bg-gray-600 hover:bg-gray-500 text-white font-bold py-2 px-4 rounded">
                                            Go Back
                                        </button>
                                    </div>
                                </form>
                            </div>
                        )}
                        {step === 'generate' && (
                            <div>
                                <p className="mb-4 text-sm sm:text-base text-white">Generate a dispute letter for: {disputeType1}</p>

                                <div className="flex flex-col justify-between sm:flex-row sm:flex-wrap sm:space-x-4 mb-4">
                                    <div>
                                    <button
                                        onClick={() => generateDisputeLetter()}
                                        disabled={loading}
                                        className="bg-green-600 hover:bg-green-500 text-white mr-3 font-bold py-2 px-3 sm:px-4 rounded mb-2 sm:mb-0"
                                    >
                                        {loading ? 'Generating...' : 'Generate Dispute Letter'}
                                    </button>

                                    <button
                                        onClick={goBack}
                                        className="bg-gray-600 hover:bg-gray-500 text-white mr-3 font-bold px-3 sm:px-4 py-2 rounded mb-2 sm:mb-0"
                                    >
                                        Go Back
                                    </button>

                                    <a
                                        href="https://www.consumerfinance.gov/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="bg-blue-600 hover:bg-blue-500 text-white font-bold py-2 px-3 sm:px-4 py-2 rounded mb-2 sm:mb-0"
                                    >
                                        Go To Consumerfinance
                                    </a>
                                    </div>
                                    <div>
                                    {(PlanTypeName?.includes('Lifetime Access')||PlanTypeName?.includes("Elite Plan")) ? (<>{generatedLetter &&showMail===1? (<button
                                        onClick={handleMail}
                                        className="bg-gray-600 order-last hover:bg-gray-500 text-white font-bold px-3 sm:px-4 py-2 rounded mb-2 sm:mb-0"
                                    >
                                        Send Direct Mail
                                    </button>):null}</>) 
                                    : (<>{generatedLetter && (<button
                                        onClick={() => navigate('/app/subscription')}
                                        className=" bg-gray-600 order-last hover:bg-gray-500 text-white font-bold px-3 sm:px-4 py-2 rounded mb-2 sm:mb-0 "
                                    ><LockIcon />
                                        Send Direct Mail
                                    </button>)}</>)}
                                    </div>

                                </div>

                                {generatedLetter && showMail === 1 ? (
                                    <div className="bg-[#2A2A2A] p-3 sm:p-4 rounded-lg mt-4">
                                        {/* <h3 className="text-lg sm:text-xl font-bold mb-2 text-white">Generated Dispute Letter:</h3> */}
                                        <pre className="whitespace-pre-wrap text-sm sm:text-base text-white">{generatedLetter}</pre>
                                    </div>
                                ) : null}
                                {showMail === 2 ? (<><ReactQuill
                                    value={generatedLetter1}
                                    onChange={setGeneratedLetter1}
                                    theme="snow"
                                    placeholder=""
                                    className="p-2.5 w-full text-sm min-h-[400px] text-white bg-gray-900 rounded-lg border focus:ring-blue-500 focus:border-blue-500  dark:border-gray-600 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                /><div className="flex justify-center space-x-4 mt-4">
                                        <button
                                            type="button"
                                            className="bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded"
                                            onClick={() => { setShowMail(1) }}

                                        >
                                            Cancel
                                        </button>

                                        <button
                                            type="submit"
                                            className="bg-green-600 hover:bg-green-500 text-white font-bold py-2 px-4 rounded"
                                            onClick={handleSubmit}
                                        >
                                            {loading ? 'Sending Mail...' : 'Submit'}
                                        </button>
                                    </div></>) : (<></>)}
                                <Modal
                                    isOpen={isModalOpen}
                                    onRequestClose={closeModal}
                                    className="fixed inset-0 flex items-center justify-center z-50"
                                    overlayClassName="fixed inset-0 bg-black bg-opacity-50 z-40"
                                >
                                    <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
                                        <h2 className="text-2xl font-semibold text-center mb-4">Mail Sent Successfully</h2>
                                        <p className="text-center mb-6">Your mail has been sent successfully!</p>
                                        <div className="flex justify-center">
                                            <button
                                                onClick={closeModal}
                                                className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
                                            >
                                                OK
                                            </button>
                                        </div>
                                    </div>
                                </Modal>
                            </div>
                        )}
                    </div>
                </div>
            </main>

        </div>
    );
};

export default RemoveCollections;